import { render, staticRenderFns } from "./HorizontalCheckBoxes.vue?vue&type=template&id=2956a488&"
import script from "./HorizontalCheckBoxes.vue?vue&type=script&lang=js&"
export * from "./HorizontalCheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCheckBoxes.vue?vue&type=style&index=0&id=2956a488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports